import { CandidateNavbarDataTestIds } from 'data-testids/general';
import { NotificationLabel } from '../MenuLabels/NotificationLabel';
import { CandidateNavigationMenuOptionInterface, NotificationData } from '../types';
import {
  handleMatchDashboardRedirect,
  contactSupportOnClickHandler,
  handleCandidateProfileRedirect,
  handleLogout,
  handleMatchArchiveDashboardRedirect,
} from './utils';
import { candidatePortalRoutes } from 'utils/constants/urls';
import StarIcon from '@mui/icons-material/Star';
import PersonIcon from '@mui/icons-material/Person';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import LogoutIcon from '@mui/icons-material/Logout';
import HistoryIcon from '@mui/icons-material/History';

export enum TabKeys {
  MATCHES = 'matches',
  MATCH_ARCHIVE = 'match-archive',
  PROFILE = 'profile',
  SUPPORT = 'support',
  LOGOUT = 'logout',
}

export const candidateMenuOptions: CandidateNavigationMenuOptionInterface<NotificationData>[] = [
  {
    key: TabKeys.MATCHES,
    label: ({ count, shouldShowNotification, context, isSelected }) => (
      <NotificationLabel
        label={'New Matches'}
        count={count}
        shouldShowNotification={shouldShowNotification}
        context={context}
        dataTestId={CandidateNavbarDataTestIds.USER_MENU_MATCH_DASHBOARD_LABEL}
        isSelected={isSelected}
      />
    ),
    icon: <StarIcon />,
    dataTestId: CandidateNavbarDataTestIds.USER_MENU_MATCH_DASHBOARD,
    shouldShowCandidatePortalNavTab: true,
    menuSection: 'main',
    href: candidatePortalRoutes.MATCH_DASHBOARD,
    menuItemAction: (params) =>
      handleMatchDashboardRedirect(
        params.isOnConnect,
        params.userType,
        params.jobBoardState,
        params.connectContextActions,
        params.history
      ),
    notification: {
      dataKey: 'candidateMatches',
      config: {
        getData: (data: NotificationData) => data.candidateMatches?.pending?.length || 0,
        shouldShow: ({ atMatchDashboard }) => !atMatchDashboard,
      },
    },
  },
  {
    key: TabKeys.MATCH_ARCHIVE,
    label: 'Match Archive',
    icon: <HistoryIcon />,
    dataTestId: CandidateNavbarDataTestIds.USER_MENU_MATCH_ARCHIVE,
    shouldShowCandidatePortalNavTab: true,
    menuSection: 'main',
    href: candidatePortalRoutes.MATCH_ARCHIVE_DASHBOARD,
    menuItemAction: (params) =>
      handleMatchArchiveDashboardRedirect(
        params.isOnConnect,
        params.userType,
        params.jobBoardState,
        params.connectContextActions,
        params.history
      ),
  },
  {
    key: TabKeys.PROFILE,
    label: 'Profile',
    icon: <PersonIcon />,
    dataTestId: CandidateNavbarDataTestIds.USER_MENU_PROFILE,
    shouldShowCandidatePortalNavTab: false,
    menuSection: 'footer',
    menuItemAction: (params) =>
      handleCandidateProfileRedirect(
        params.isOnConnect,
        params.userType,
        params.jobBoardState,
        params.connectContextActions,
        params.history
      ),
  },
  {
    key: TabKeys.SUPPORT,
    label: 'Get Support',
    icon: <ContactSupportIcon />,
    dataTestId: CandidateNavbarDataTestIds.USER_MENU_SUPPORT,
    shouldShowCandidatePortalNavTab: false,
    menuSection: 'footer',
    menuItemAction: () => contactSupportOnClickHandler(),
  },
  {
    key: TabKeys.LOGOUT,
    label: 'Sign out',
    icon: <LogoutIcon />,
    dataTestId: CandidateNavbarDataTestIds.USER_MENU_LOGOUT,
    shouldShowCandidatePortalNavTab: false,
    menuSection: 'footer',
    menuItemAction: (params) => handleLogout(params.connectUrlPath),
  },
];
